import _ from "lodash";
import CsvStringify from "csv-stringify/lib/sync";
import MegaraxClient from "./megaraxClient";

export type DumpAction = (
  convertToDsv?: boolean,
  delimiter?: string,
) => Promise<any>;

export const getDumpAction =
  (resourceUrl: string, labelMap: { key: string; header: string }[]) =>
  (client: MegaraxClient): DumpAction =>
  async (convertToDsv = false, delimiter = ",") => {
    const { data } = await client.get(`${resourceUrl}dump/`);

    const transformObject = (obj: any) => {
      const result: any = {};
      for (const { header, key } of labelMap) {
        result[header] = _.get(obj, key, null);
      }
      return result;
    };

    const dataWithConvertedLabels = data.map(transformObject);

    if (convertToDsv)
      return CsvStringify(dataWithConvertedLabels, { header: true, delimiter });
    return dataWithConvertedLabels;
  };
